import React, {Component} from 'react'
import { Button, Modal, ModalHeader, ModalBody, ModalFooter } from 'reactstrap';

class AprobarModal extends Component{
    onSubmit(){
        this.props.action();
        this.props.toggler();
    }
    render(){
        return(
            <Modal className="modal-dialog-centered" isOpen={this.props.show} toggle={this.props.toggler}>
                <ModalHeader toggle={this.props.toggler}>No aceptar presupuesto</ModalHeader>
                <ModalBody>
                    <p>La NO aceptación del tratamiento implica la renuncia a la producción del caso y la satisfacción del pago del estudio. El estudio realizado seguirá a su disposición siendo posible su reactivación  del caso siempre sobre los modelos sobre los que se realizó el estudio.</p>
                </ModalBody>
                <ModalFooter>
                    <Button color="link" onClick={this.props.toggler}>Cancelar</Button>
                    <Button color="primary" onClick={this.onSubmit.bind(this)}>Rechazar</Button>{' '}
                </ModalFooter>
            </Modal>

        )
    }
}
export default AprobarModal


// WEBPACK FOOTER //
// ./resources/assets/js/components/viewer/RejectModal.jsx